<template>
  <v-row justify="center" class="mt-8 mb-8">
    <div class="text-center">
      <v-pagination
        @next="page + 1"
        @previous="page - 1"
        v-model="page"
        :length="lastPage"
        :total-visible="8"
      ></v-pagination>
    </div>
  </v-row>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    lastPage: {
      type: Number
    },
    selected_symptoms: {
      type: Array
    },
    selected_specializations: {
      type: Array
    },
    selected_sex: {
      type: Array
    },
    selected_sort_option: {
      type: Object
    }
  },
  data () {
    return {
      page: 1
    }
  },
  computed: {
    getSelectedConsultationType () {
      return this.$store.getters['consultation_type/getSelectedConsultationType']
    },
  },
  watch: {
    page () {
      this.$emit('loadEvent')
      this.$store.dispatch('user/getPsychologists', { page: this.page, selected_symptoms: this.selected_symptoms, selected_specializations: this.selected_specializations, selected_sex: this.selected_sex, selected_sort_option: this.selected_sort_option.id, consultation_type_id: this.getSelectedConsultationType })
        .then((response) => {
          this.$emit('loadEvent')
          this.lastPage = response.data.meta.last_page
        })
    },
    filter () {
      this.page = 1
    }
  }
}
</script>

<style scoped>

</style>
